import styles from "./styles.module.scss";
import { useNavigate } from "react-router-dom";

const HERO_CONTENT = {
  walky: {
    title: "Effective & Gentle Walking <br /> Routines for every goal",
    style: "heroWalky",
  },
  easyfit: {
    title: "Easy & Effective <br /> Workouts <br /> for your goal",
    style: "hero",
  },
};

export const Hero = ({ isWalky }) => {
  const navigate = useNavigate();
  
  const variant = isWalky ? HERO_CONTENT.walky : HERO_CONTENT.easyfit;

  const openQuestionnaire = () => {
    navigate("/onboarding/1");
  };

  return (
    <section className={styles[variant.style]}>
      <div className={styles.title}>
        <h1 dangerouslySetInnerHTML={{ __html: variant.title }} />
        <button onClick={openQuestionnaire} className={styles.cta}>
          Get Started
        </button>
      </div>
    </section>
  );
};
